import apiClient from "./APIClient";

export const getBundleCategories = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('lang', 'en');
    
    if (filters.search) {
      params.append('search', filters.search);
    }
    
    const res = await apiClient.get(`/productCategory/bundles/all?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching bundle categories:", error);
    throw error;
  }
};

export const getBundleTypes = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('lang', 'en');
    
    if (filters.search) {
      params.append('search', filters.search);
    }
    
    const res = await apiClient.get(`/productTypes/bundles/all?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching bundle types:", error);
    throw error;
  }
};

export const getDataProducts = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('lang', 'en');
    
    if (filters.countryId) {
      params.append('countryId', filters.countryId);
    }
    if (filters.productCategoryId) {
      params.append('productCategoryId', filters.productCategoryId);
    }
    if (filters.productTypeId) {
      params.append('productTypeId', filters.productTypeId);
    }
    if (filters.search) {
      params.append('search', filters.search);
    }
    if (filters.prefix) {
      params.append('prefix', filters.prefix);
    }
    
    const res = await apiClient.get(`/product/agent/data?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching data products:", error);
    throw error;
  }
};

export const activateDataBundle = async (payload) => {
  try {
    const res = await apiClient.post(`/bundle-activation/agent?lang=en`, payload);
    return res.data;
  } catch (error) {
    console.error("Error activating data bundle:", error);
    throw error;
  }
};

export const getAgentBundleOrders = async (userId, filters = {}) => {
  try {
    const params = new URLSearchParams();
    
    // Add filters
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const res = await apiClient.get(`/bundle-activation/agent-orders?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching bundle orders:", error);
    throw error;
  }
};

export const getCountries = async () => {
  try {
    const res = await apiClient.get('/country?lang=en');
    return res.data;
  } catch (error) {
    console.error("Error fetching countries:", error);
    throw error;
  }
};

export const getOrderStatus = async (orderId) => {
  try {
    const res = await apiClient.get(`/orders/${orderId}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching order status:", error);
    throw error;
  }
};